import { FlashMessage } from "../components/common";
import appRoutes from "../routes/app.routes";
import navigate from "./history";

interface commpanyProps {
  slug: string;
  access_level: string;
}
export const commpanyStatus = (companyAccess: commpanyProps) => {
  const { access_level, slug } = companyAccess;
  const pathname = window.location.pathname;

  if (access_level === "admin") {
    return "admin";
  } else if (access_level === "sale_recruiter") {
    if (
      !pathname.includes("dashboard") &&
      !pathname.includes("candidates") &&
      !pathname.includes("jobs")
    ) {
      FlashMessage("Acces Forbidden", "error");
      return navigate(appRoutes.companyDashboard.generatePath(slug));
    }
    return "sale_recruiter";
  } else if (access_level === "marketing") {
    if (!pathname.includes("dashboard")) {
      FlashMessage("Acces Forbidden", "error");
      return navigate(appRoutes.companyDashboard.generatePath(slug));
    }
    return "marketing";
  }
};
